import Vue from 'vue';
import router from '@/router/index'

function mostrarLoaderCambioPerfil() {
  if (typeof $ !== 'undefined') {
    $('.preloader').stop(true, true).fadeIn(150);
  }
}

function ocultarLoaderCambioPerfil() {
  if (typeof $ !== 'undefined') {
    $('.preloader').stop(true, true).fadeOut(150);
  }
}

function parseJsonResponse(respuesta) {
  if (respuesta && respuesta.body !== undefined && respuesta.body !== null && respuesta.body !== '') {
    return typeof respuesta.body === 'object' ? respuesta.body : JSON.parse(respuesta.body);
  }
  if (respuesta && typeof respuesta.json === 'function') {
    return respuesta.json();
  }
  return respuesta;
}

function navegarDashboard() {
  return router.push({ name: 'Dashboard' }).catch(function (err) {
    if (
      err &&
      (err.name === 'NavigationDuplicated' ||
        (err.message && err.message.indexOf('Avoided redundant navigation') >= 0))
    ) {
      return;
    }
    throw err;
  });
}

export default {
    state:{
      perfiles:{
        perfiles:[],
        perfiles_secciones:[],
        secciones:[]
      },
      cambiandoPerfil: false
    },
    mutations: {
      setPerfiles(state,perfiles){
        state.perfiles.perfiles=perfiles;
      },
      setPerfiles_Secciones(state,perfiles_secciones){
        state.perfiles.perfiles_secciones=perfiles_secciones;
      },
      setSecciones(state,secciones){
        state.perfiles.secciones=secciones;
      },
      setCambiandoPerfil(state, valor){
        state.cambiandoPerfil = valor;
      }
    },
    actions: {
      Cambiar_Perfil_Usuario(context,perfil){
        if (context.state.cambiandoPerfil) {
          return;
        }
        context.commit('setCambiandoPerfil', true);
        mostrarLoaderCambioPerfil();

        let exito = false;
        Vue.http.post('perfiles/cambiar_perfil',{
          perfil:perfil
        })
        .then(respuesta => parseJsonResponse(respuesta))
        .then(respuestaJson=>{
            if (respuestaJson.resp=='Excelente') {
              exito = true;
              context.dispatch('Actualizar_Usuario',{
                usuario:respuestaJson.usuario,
                token:respuestaJson.token
              });
              localStorage.setItem('perfil_sistema', respuestaJson.usuario.perfil_sistema);
              return navegarDashboard();
            }
            swal("¡Ups!", "Problemas para cambiar de perfil", "error");
        })
        .then(() => {
          if (!exito) {
            return;
          }
          return Vue.nextTick();
        })
        .catch(error=>{
          console.log(error)
          if (!exito) {
            swal("¡Ups!", "Problemas para cambiar de perfil", "error");
          }
        })
        .then(() => {
          ocultarLoaderCambioPerfil();
          context.commit('setCambiandoPerfil', false);
        });
      },
      Consultar_Secciones(context,definir_permisos){

        Vue.http.get('perfiles/secciones/perfiles')
        .then(respuesta=>{return respuesta.json()})
        .then(respuestaJson=>{
          context.commit('setPerfiles',respuestaJson.perfiles);
          context.commit('setPerfiles_Secciones',respuestaJson.perfiles_secciones);
          context.commit('setSecciones',respuestaJson.secciones);
          if (definir_permisos==true) {
            context.dispatch('Definir_Permisos_Del_Usuario');
          }
        })
        .catch(error=>{
          //swal("¡Ups!", "Problemas para consultar los perfiles del empleado", "error");
        });
      }
    },
    getters: {
      getPerfiles(state){
        return state.perfiles.perfiles;
      },
      getPerfiles_Secciones(state){
        return state.perfiles.perfiles_secciones;
      },
      getSecciones(state){
        return state.perfiles.secciones;
      }
    },

}



// WEBPACK FOOTER //
// C:/Users/cesar/Documents/dev/LMSEDK/LMSDEKTernium-clone/D:/dev/LMSEDK/LMSDEKTernium-clone/src/modules/perfiles.js